import React, { useCallback, useEffect, useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import { getReturnsNotifications } from "../../services/notificationService";
import { getRouteUpdatesForClient } from "../../services/deliveryConcernService";
import {
  // displayPieceType,
  localStorageVariables,
  pages,
  viewStates,
} from "../../constants";
import { LoadingSpinner } from "../Utility/LoadingSpinner";
import { format as dateFormat } from "date-fns";
import { RiNotificationLine } from "react-icons/ri";
import { Link } from "react-router-dom";
import { MdOutlineSubject } from "react-icons/md";
import { TooltipMouseTrack } from "../Utility/TooltipMouseTrack";
import { openInNewTab } from "../../helpers/utilities";
import { MoreDetailsIcon } from "../Utility/Icons/MoreDetailsIcon";
import handleApiError from "../../helpers/handleApiError";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const notificationTabs = {
  all: { title: "All" },
  returnRequests: {
    title: "Return Requests",
    uniqueIdentifier: "id",
    key: "returnRequests",
  },
  routeAlerts: {
    title: "Route Alerts",
    uniqueIdentifier: "tranId",
    key: "routeAlerts",
  },
  // test: {
  //   title: "Test",
  // },
  // test2: {
  //   title: "Test2",
  // },
  // test3: {
  //   title: "Test3",
  // },
  // test4: {
  //   title: "Test4",
  // },
};

const notificationCategoryExtraDataMap = {
  [notificationTabs.returnRequests.title]: {
    uniqueIdentifier: "id",
    redirectUrl: pages.returnRequest.url,
    total: 0,
  },
  [notificationTabs.routeAlerts.title]: {
    uniqueIdentifier: "tranId",
    redirectUrl: pages.viewConcern.url,
  },
};

// const categoryMaxHeight = 270;
// const categoryMinHeight = 250;
// const categoryMinHeight = 220;
const categoryMinHeightEmpty = 170;
const categoryMinHeight = 300;

const NotificationModal = ({ show, onHide, category, data }) => {
  // console.log(category);
  // console.log(data);
  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header>
        <Modal.Title className="w-100">
          {category === notificationTabs.routeAlerts.title && (
            <div className="d-flex justify-content-between">
              <div>Route Alert - {data.route}</div>
              <div>{dateFormat(Date.parse(data.entered), "MM/dd/yyyy")}</div>
            </div>
          )}
          {/* {category === notificationTabs.returnRequests.title &&
            "Return Request TODO"} */}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {category === notificationTabs.routeAlerts.title && (
          <div className="px-2">
            <div className="d-flex justify-content-between mb-2">
              {/* <div className="font-600 mb-3">{data.route}</div> */}
              <div className="font-600">{data.subject}</div>
              {/* <div>{data.route}</div> */}
              {/* <div>{dateFormat(Date.parse(data.entered), "MM/dd/yyyy")}</div> */}
            </div>
            <div>{data.e_Body}</div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        {/* {category === notificationTabs.routeAlerts.title && (
          <button className="btn btn-primary">
            View Affected Orders - should take to order history with query
            parameters. hopefully shouldn't load if already on order-history
          </button>
        )} */}
        <button className="btn btn-secondary" type="button" onClick={onHide}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

const NotificationsDropdownToggle = React.forwardRef(
  ({ onClick, totalUnreadNotifications }, ref) => {
    return (
      <>
        <div className="d-block d-lg-none dropdown nav-item">
          <a
            href="#"
            className="dropdown-toggle nav-link"
            ref={ref}
            onClick={(e) => {
              e.preventDefault();
              onClick(e);
            }}
          >
            Notifications (
            {totalUnreadNotifications > 99 ? "99+" : totalUnreadNotifications})
          </a>
        </div>
        <div
          className="d-none d-lg-block"
          style={{
            position: "relative",
            width: "40px",
            height: "40px",
            // backgroundColor: "green",
          }}
        >
          <button
            ref={ref}
            onClick={(e) => {
              e.preventDefault();
              onClick(e);
            }}
            style={{
              backgroundColor: "transparent",
              border: "none",
              boxShadow: "none",
              outline: "none",
              display: "block",
              boxSizing: "border-box",
              position: "relative",
              height: "100%",
              width: "100%",
            }}
          >
            <RiNotificationLine color="white" size={25} />
            {totalUnreadNotifications > 0 && (
              <div
                style={{
                  backgroundColor: "red",
                  width: "1.5em",
                  height: "1.5em",
                  borderRadius: "10000px",
                  position: "absolute",
                  bottom: "-3px",
                  right: "-4px",
                  border: "3px solid #343A40",
                  display: "grid",
                  placeContent: "center",
                  color: "white",
                  userSelect: "none",
                }}
              >
                <div
                  style={{
                    fontSize: "10px",
                    marginRight: totalUnreadNotifications > 99 ? "-1px" : 0,
                  }}
                >
                  {totalUnreadNotifications > 99
                    ? "99+"
                    : totalUnreadNotifications}
                </div>
              </div>
            )}
          </button>
        </div>
      </>
    );
  }
);
// const thirdTabTestDummyData = [
//   { entered: "2021/01/01" },
// ];

export const NotificationsDropdown = () => {
  const history = useHistory();
  const [notificationsData, setNotificationsData] = useState({
    [notificationTabs.returnRequests.title]: [],
    [notificationTabs.routeAlerts.title]: [],
  });
  const [selectedTab, setSelectedTab] = useState(() => {
    return (
      localStorage.getItem(localStorageVariables.lastSelectedNotificationTab) ??
      notificationTabs.all.title //change back to all as default when we add back categories.
    );
  });
  const [viewState, setViewState] = useState(viewStates.loading);

  const fetchNotifications = useCallback(async () => {
    try {
      setViewState(viewStates.loading);
      const returnRequestsResponse = await getReturnsNotifications();
      const routeAlertsResponse = await getRouteUpdatesForClient();
      setNotificationsData((prev) => ({
        ...prev,
        [notificationTabs.returnRequests.title]: {
          notifications: returnRequestsResponse.data?.sort((a, b) => {
            return b.returnDate.localeCompare(a.returnDate);
          }),
          // .slice(0, 3),
          totalOriginal: returnRequestsResponse.data.length,
          showTotalInsteadOfNew: false,
        },
        [notificationTabs.routeAlerts.title]: {
          notifications: Array.isArray(routeAlertsResponse?.data)
            ? routeAlertsResponse.data //check typeof is array because sometimes backend sends a 200 OK with the message "The underlying provider failed on Open."
                ?.map((routeAlert) => {
                  return {
                    ...routeAlert,
                    e_Body: routeAlert.e_Body?.split(
                      "Thank you for choosing Diligent"
                    )[0],
                  };
                })
                .sort((a, b) => {
                  return b.entered.localeCompare(a.entered);
                })
            : [],
          // [
          //   {
          //     entered: "2022/01/01",
          //     e_body:
          //       "help this is a route alert to tell you that there is a route alert. Route alerts are nnice to have cause they alert you",
          //   },
          // ],
        },
      }));

      setViewState(viewStates.success);
    } catch (ex) {
      // handleApiError(ex, history);
      setViewState(viewStates.error);
    }
  }, []);

  useEffect(() => {
    fetchNotifications();
  }, [fetchNotifications]);

  const handleSelectTab = (tab) => {
    setSelectedTab(tab);
    localStorage.setItem(
      localStorageVariables.lastSelectedNotificationTab,
      tab
    );
  };

  useEffect(() => {
    const intervalID = setInterval(() => {
      fetchNotifications();
    }, 300000);
    return () => {
      clearInterval(intervalID);
    };
  }, []);

  const [showDropdown, setShowDropdown] = useState(false);

  const [selectedNotification, setSelectedNotification] = useState(0);
  const [
    selectedNotificationParentCategory,
    setSelectedNotificationParentCategory,
  ] = useState("");
  const [showNotificationModal, setShowNotificationModal] = useState(false);
  const [
    notificationModalHasBeenShownBefore,
    setNotificationModalHasBeenShownBefore,
  ] = useState(false);
  const [showNotificationModalAfterimage, setShowNotificationModalAfterimage] =
    useState(false);
  useEffect(() => {
    setShowNotificationModalAfterimage(showNotificationModal);
  }, [showNotificationModal]);
  const handleShowNotificationModal = (notificationId, parentCategory) => {
    setShowNotificationModal(true);
    setSelectedNotification(notificationId);
    setSelectedNotificationParentCategory(parentCategory);
  };
  const handleCloseNotificationModal = () => {
    setShowNotificationModal(false);
    // setSelectedNotification({});
    // setSelectedNotificationParentCategory("");
  };

  // const totalNotifications = Object.values(notificationsData).reduce(
  //   (rolling, current) => {
  //     return rolling + current.length;
  //   },
  //   0
  // );
  // console.log("notificationsData", notificationsData);
  // console.log("object entries", Object.entries(notificationsData));
  const totalUnreadNotificationsObject = Object.entries(
    notificationsData
  )?.reduce((rolling, [notificationCategory, notificationsObject]) => {
    // console.log(rolling);
    const notifications = notificationsObject.notifications;
    // console.log("notificationObject", notificationsObject);
    // console.log("notification category", notificationCategory);
    return {
      ...rolling,
      [notificationCategory]: notifications?.reduce((rolling, current) => {
        // console.log("inner:", rolling);
        // console.log("inner:", current);
        return (
          rolling +
          ((localStorage.getItem(localStorageVariables.readNotifications)
            ? JSON.parse(
                localStorage.getItem(localStorageVariables.readNotifications)
              )
            : {})?.[notificationCategory]?.[
            current?.[
              notificationCategoryExtraDataMap[notificationCategory]
                .uniqueIdentifier
            ]
          ]
            ? 0
            : 1)
        );
      }, 0),
    };
  }, {});
  // console.log(
  //   "total unread notifications object: ",
  //   totalUnreadNotificationsObject
  // );
  const totalUnreadNotifications = Object.values(
    totalUnreadNotificationsObject
  ).reduce((rolling, current) => {
    return rolling + current;
  }, 0);

  // Object.keys(notificationsData).map((notificationCategory)=>{
  //   notificationsData[notificationCategory].map(()=>{

  //   })
  // })

  // console.log(notificationModalHasBeenShownBefore);
  const displayUnreadTextForCategory = (notificationCategoryTitle) => {
    if (notificationsData[notificationCategoryTitle].showTotalInsteadOfNew) {
      return notificationsData[notificationCategoryTitle]?.totalOriginal > 0
        ? ` (${notificationsData[notificationCategoryTitle].totalOriginal} Total)`
        : "";
    } else {
      return totalUnreadNotificationsObject[notificationCategoryTitle] > 0
        ? ` (${totalUnreadNotificationsObject[notificationCategoryTitle]} New)`
        : "";
    }
  };

  return (
    <Dropdown
      drop="down"
      show={showDropdown}
      onToggle={(isOpen, event, metadata) => {
        // console.log("isOpen: ", isOpen);
        // console.log("event: ", event); //If the click is outside the dropdown, event is false
        // console.log("metadata:", metadata);
        // console.log(
        //   "notification modal afterimage: " + showNotificationModalAfterimage
        // );
        // console.log("-------------------");
        //this is to prevent the dropdown from closing while the user is viewing/clicking a notification modal.
        //if you use just showNotificationModal, the dropdown will close when the modal closes, as a click outside both happens, and showNotificationModal is no longer true. Not sure why the timing is the way that it is. Since technically this should be called before the showNotifcationModal state is updated.
        //But as a workaround we can have an "afterimage" state that will get updated after this is called, so it will still be true when we close the modal and keep the dropdown open until they click outside of it again.
        //sadly, this workaround doesn't work for the escape key, even though it should. It successfully blocks the keydown event while the modal is open, but for some reason the keyup on escape also triggers the modal closing right after. However, we are passed the same data as if it were an outside click that triggered it (i.e. false/undefined everything, and even though metadata.source for keydown shows correctly it is undefined for this keyup trigger), so we have no way of knowing inside this function.
        if (showNotificationModalAfterimage) {
        } else {
          setShowDropdown(isOpen);
          if (!isOpen) {
            let readNotifications = {};
            Object.keys(notificationsData).map((notificationCategory) => {
              // console.log(notificationCategory);
              const readNotificationIDs = notificationsData[
                notificationCategory
              ].notifications.reduce((rolling, currentNotification) => {
                return {
                  ...rolling,
                  [currentNotification[
                    notificationCategoryExtraDataMap[notificationCategory]
                      .uniqueIdentifier
                  ]]: 1, //We were previously setting the value to true but changed to 1 to save some space in localstorage
                };
              }, {});
              readNotifications[notificationCategory] = readNotificationIDs;
            });
            // console.log(readNotifications);
            localStorage.setItem(
              localStorageVariables.readNotifications,
              JSON.stringify(readNotifications)
            );
            if (!notificationModalHasBeenShownBefore) {
              setNotificationModalHasBeenShownBefore(true);
            }
          }
        }
      }}
    >
      <Dropdown.Toggle
        as={NotificationsDropdownToggle}
        totalUnreadNotifications={totalUnreadNotifications}
      ></Dropdown.Toggle>
      <Dropdown.Menu className="navbar-dropdown-right-align p-2 ">
        <NotificationModal
          show={showNotificationModal}
          onHide={handleCloseNotificationModal}
          category={selectedNotificationParentCategory}
          data={
            notificationsData?.[selectedNotificationParentCategory]
              ?.notifications?.[selectedNotification] ?? {}
          }
        />
        <div
          className="d-flex flex-column"
          style={{
            minHeight: "570px",
            maxHeight: "730px",
            width: "320px",
            // overflow: "auto",
          }}
        >
          <div>
            <div
              id="notification-tabs-container"
              style={{ overflow: "auto" }}
              className="navbar-notifications-tab-container"
            >
              {Object.values(notificationTabs).map((tab) => {
                return (
                  <div
                    role="tab"
                    key={tab.title}
                    className={`font-semi-small tag-tab ${
                      selectedTab === tab.title ? "tag-tab-active" : ""
                    }`}
                    style={{
                      float: "left",
                      padding: ".2rem .5rem",
                      margin: ".2rem .15rem",
                    }}
                    onClick={() => {
                      handleSelectTab(tab.title);
                    }}
                  >
                    {tab.title}
                    {
                      //logic to calculate and display amount of unread notifications in each category
                      // {totalUnreadNotificationsObject[tab.title]
                      //   ? ` (${totalUnreadNotificationsObject[tab.title]})`
                      //   : ""} }
                      // {totalUnreadNotificationsObject[tab.title]
                      //   ? ` (${totalUnreadNotificationsObject[tab.title]}/${
                      //       notificationsData[tab.title].length
                      //     })`
                      //   : ""}
                    }
                  </div>
                );
              })}
            </div>
            <div className="px-2">
              <hr className="my-2" />
            </div>
          </div>

          {viewState === viewStates.loading && (
            <div
              className="transparent"
              style={{
                display: "flex",
                flex: 1,
              }}
            >
              <LoadingSpinner
                containerStyleAppend={{
                  display: "grid",
                  width: "100%",
                  placeContent: "center",
                }}
              />
            </div>
          )}
          {(viewState === viewStates.success ||
            viewState === viewStates.nodata) && (
            <div
              id="notifications-data-container"
              className="p-2 custom-scrollbar"
              style={{
                minHeight: 0,
                flex: 1,
                overflow: "auto",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {Object.entries(notificationsData)
                .filter((entry) => {
                  return (
                    selectedTab === notificationTabs?.all?.title ||
                    selectedTab === entry[0]
                  );
                })
                .map(([tabTitle, tabDataObject]) => {
                  const tabData = tabDataObject.notifications;
                  return (
                    <div
                      className="mb-4 d-flex flex-column"
                      style={{
                        minHeight:
                          tabDataObject.notifications?.length > 0
                            ? categoryMinHeight
                            : categoryMinHeightEmpty,
                      }}
                      key={tabTitle}
                    >
                      {/* TODO change mb-2 back to my-2 when we readd multiple notification categories*/}
                      <div className="d-flex justify-content-between mb-2 align-items-center">
                        <span
                          className="text-note font-600"
                          // style={{ display: "grid", placeContent: "end" }}
                        >
                          {tabTitle}
                          {displayUnreadTextForCategory(tabTitle)}
                        </span>
                        {notificationCategoryExtraDataMap?.[tabTitle]
                          ?.redirectUrl && (
                          <TooltipMouseTrack message="View All">
                            <Link
                              to={
                                notificationCategoryExtraDataMap[tabTitle]
                                  .redirectUrl
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-icon btn-small grid-center text-note"
                            >
                              {/* <PiListBullets size={25} /> */}
                              <MoreDetailsIcon />
                            </Link>
                          </TooltipMouseTrack>
                        )}
                      </div>
                      {/* hr not showing now that this is in flex container but I think it looks better without them */}
                      {/* <hr className="my-2" /> */}
                      <div
                        className="position-relative"
                        style={{
                          flex: 1,
                          minHeight: 0,
                          display: "flex",
                        }}
                      >
                        <div
                          className="panel-inset-overlay"
                          style={{ borderRadius: ".25rem" }}
                        ></div>
                        <div
                          id="notification-category-container"
                          className="px-2 py-1 custom-scrollbar"
                          style={{
                            flex: 1,
                            maxHeight: "100%",
                            minHeight: 0,
                            overflow: "auto",
                            backgroundColor: "rgb(250, 251, 252)",
                            borderRadius: ".25rem",
                          }}
                        >
                          {tabData?.length > 0 ? (
                            tabData.map((notification, index) => {
                              if (
                                tabTitle ===
                                notificationTabs?.returnRequests?.title
                              ) {
                                return (
                                  <div
                                    key={
                                      notification[
                                        notificationCategoryExtraDataMap[
                                          tabTitle
                                        ].uniqueIdentifier
                                      ]
                                    }
                                    className="panel-flat px-2 py-1 my-2 text-note font-small bg-main clickable no-copy"
                                    onClick={() => {
                                      openInNewTab(
                                        notificationCategoryExtraDataMap[
                                          tabTitle
                                        ].redirectUrl,
                                        true
                                      );
                                    }}
                                  >
                                    <div className="d-flex justify-content-between">
                                      <div className="font-600 pr-4">
                                        {notification.customerName ??
                                          "Name not found"}
                                      </div>
                                      <div>
                                        {notification.returnDate
                                          ? dateFormat(
                                              Date.parse(
                                                notification.returnDate
                                              ),
                                              "MM/dd/yyyy"
                                            )
                                          : ""}
                                      </div>
                                    </div>
                                    <div>
                                      <span className="font-600">
                                        {notification.invoiceNumber}
                                      </span>{" "}
                                      {/* {displayPieceType(notification.quantity, notification.pieceType)} //change to this when piece type is info is sent from backend*/}
                                      - Quantity: {notification.quantity}
                                      {/* / {notification.totalPieces} // Removed this "__/total" display, since we will no longer be limiting the return to the total quantity of the original order or how many returns they can place (example case for why: the original order was 1 package with multiple parts inside. Customer wants returns some of the parts in a box. Later on they return some more parts.) */}
                                    </div>
                                    <div></div>
                                    <div className="line-clamp-base line-clamp-3">
                                      {notification.comment}
                                    </div>
                                  </div>
                                );
                              } else if (
                                tabTitle === notificationTabs.routeAlerts.title
                              ) {
                                return (
                                  <div
                                    key={
                                      notification[
                                        notificationCategoryExtraDataMap[
                                          tabTitle
                                        ].uniqueIdentifier
                                      ]
                                    }
                                    className={`panel-flat notification-panel px-2 py-1 my-2 text-note font-small bg-main clickable no-copy ${
                                      tabTitle ===
                                        selectedNotificationParentCategory &&
                                      index === selectedNotification &&
                                      showNotificationModal
                                        ? "notification-panel-active"
                                        : ""
                                    }`}
                                    onClick={() => {
                                      handleShowNotificationModal(
                                        index,
                                        tabTitle
                                      );
                                    }}
                                  >
                                    <div className="d-flex justify-content-between font-600 mb-1">
                                      <div
                                      // style={{ color: "black" }}
                                      >
                                        {notification.route}
                                      </div>
                                      <div>
                                        {dateFormat(
                                          Date.parse(notification.entered),
                                          "MM/dd/yyyy"
                                        )}
                                      </div>
                                    </div>
                                    <div className="font-600">
                                      {notification.subject}
                                    </div>
                                    <div className="line-clamp-base line-clamp-3">
                                      {notification.e_Body}
                                    </div>
                                  </div>
                                );
                              }
                            })
                          ) : (
                            <div
                              style={{
                                display: "grid",
                                placeContent: "center",
                                height: "100%",
                              }}
                              className="font-600"
                            >
                              None
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          )}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};
